/*
 * @Describe:
 * @Author: wangalong
 * @LastEditTime: 2022-09-23 16:14:32
 */
import { reactive, ref, Ref, UnwrapRef } from 'vue'

export function useAsync<Request extends (...params: any[]) => any>(
    handle: Request,
): Request & {
    status: {
        loading: boolean
        error: any
        // 执行成功过
        done: boolean
        /** 执行成功,每次发出请求即重置 */
        finished: boolean
    }
    data: Ref<UnwrapRef<Awaited<ReturnType<Request>>> | undefined>
    request: Request
} {
    const status = reactive({ loading: false, error: null, done: false, finished: false })
    const data = ref<Awaited<ReturnType<Request>> | null>(null)

    const request = async function(...params: Parameters<Request>) {
        status.loading = true
        status.finished = false
        try {
            const result = await Promise.resolve(handle.apply(this, params))
            data.value = result
            status.loading = false
            status.finished = true
            status.done = true
            return result
        } catch (error) {
            status.loading = false
            status.error = error

            return Promise.reject(error)
        }
    }

    request.status = status
    request.data = data
    request.request = request

    // @ts-ignore
    return request
}
